enum DSQLocationTypeEnum {
    HOSP,  // Centre hospitalier
    CHR,   // Centre d'hébergement et de soins de longue durée
    OF,    // Clinique
    CCC,   // Centre local de services communautaires
    RH,    // Centre de réadaptation
    LSIND, // Lieu pour services indirects
    PHARM  // Pharmacie
}

export { DSQLocationTypeEnum };
